import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';


import IUplaod from 'icons/IUplaod';

export type CheckButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const UploadButtonAction = ({
  children = 'Upload',
  onlyIcon = false,
  ...otherProps
}: CheckButtonProps) => {
  return (
    <Button icon={<IUplaod twoToneColor="Green" />} style={{ height: 40 }} {...otherProps}>
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default UploadButtonAction;

